import React, { Component } from 'react'

interface InputLabelProps {
  text?: string
}

export default class InputLabel extends Component<InputLabelProps> {
  render () {
    return Boolean(this.props.text) &&
      <label className="block mb-1">{this.props.text}</label>
  }
}
